import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { AuthContext } from "../context/AuthContext";
import { THEME_MODES, applyThemeToDocument, getInitialThemeMode } from "../services/theme";

const NavThemeToggle = () => {
    const [mode, setMode] = useState(getInitialThemeMode);

    useEffect(() => {
        applyThemeToDocument(mode);
    }, [mode]);

    const cycle = () => {
        setMode((current) => {
            const next = THEME_MODES[(THEME_MODES.indexOf(current) + 1) % THEME_MODES.length];
            localStorage.setItem("webcrm-theme", next);
            return next;
        });
    };

    return (
        <button
            type="button"
            className="theme-toggle nav-theme-toggle"
            onClick={cycle}
            title={`Тема: ${mode}`}
        >
            {mode === "dark" ? <Moon size={16} /> : <Sun size={16} />}
        </button>
    );
};

const Navbar = () => {
    const { user, handleLogout } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogoutAndRedirect = async () => {
        await handleLogout();
        navigate("/login");
    };

    return (
        <nav>
            {user ? (
                <>
                    <div className="nav-user">Вы вошли как {user.username}</div>
                    <div className="nav-links">
                        <Link to="/">CRM</Link>
                        <Link to="/counterparties">Контрагенты</Link>
                        <div className="nav-tools">
                            <button
                                type="button"
                                className="nav-tools-trigger"
                                aria-haspopup="true"
                            >
                                Инструменты
                            </button>
                            <div className="nav-tools-menu">
                                <Link to="/price-monitoring">Цены</Link>
                                <a href="/tier/" target="_blank" rel="noreferrer">Tier</a>
                                <a href="/azs-landing/" target="_blank" rel="noreferrer">AZS Landing</a>
                            </div>
                        </div>
                        <Link to="/site-tasks">Текущие задачи</Link>
                        <Link to="/conf">Конференции</Link>
                        {user.isSuperadmin && <Link to="/admin/users">Админка</Link>}
                    </div>
                    <div className="nav-actions">
                        <NavThemeToggle />
                        <button onClick={handleLogoutAndRedirect}>Выйти</button>
                    </div>
                </>
            ) : (
                <div className="nav-links">
                    <Link to="/register">Регистрация</Link>
                    <Link to="/login">Войти</Link>
                    <div className="nav-actions">
                        <NavThemeToggle />
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navbar;
